// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Titre_titre__9Pc9g {\n  text-align: center;\n}\n.Titre_mobile__0i6R6 {\n  font-size: 22px;\n  margin: 25px 0px;\n}\n", "",{"version":3,"sources":["webpack://./src/Components/Titre/Titre.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".titre {\n  text-align: center;\n}\n.mobile {\n  font-size: 22px;\n  margin: 25px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titre": "Titre_titre__9Pc9g",
	"mobile": "Titre_mobile__0i6R6"
};
export default ___CSS_LOADER_EXPORT___;
